import * as Yup from 'yup';
import { DictActType } from '@models';

export function useValidationSchema() {
  return Yup.object<DictActType>().shape({
    name: Yup.string().nullable().required(),
  });
}
